import { getClientTrialDays } from 'utilities/client-trials'
import useTargetAudience from './use-target-audience'

export function useClientTrialDays() {
  const targetAudience = useTargetAudience()

  return getClientTrialDays(targetAudience)
}
